module.exports = __webpack_public_path__ + "img/shell-ic.40693d13.svg";